<script setup lang="ts">
const emit = defineEmits<{
  (event: "submit", value: Event): void;
}>();

const onSubmit = (e: Event) => {
  e.preventDefault();

  emit("submit", e);
};
</script>

<template>
  <form @submit="onSubmit">
    <slot />
  </form>
</template>
